(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('technicien', {
            parent: 'gestion',
            url: '/technicien?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'tmgApp.technicien.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/technicien/techniciens.html',
                    controller: 'TechnicienController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('technicien');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('technicien-detail', {
            parent: 'technicien',
            url: '/technicien/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'tmgApp.technicien.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/technicien/technicien-detail.html',
                    controller: 'TechnicienDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('technicien');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Technicien', function($stateParams, Technicien) {
                    return Technicien.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'technicien',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('technicien-detail.edit', {
            parent: 'technicien-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/technicien/technicien-dialog.html',
                    controller: 'TechnicienDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Technicien', function(Technicien) {
                            return Technicien.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('technicien.new', {
            parent: 'technicien',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/technicien/technicien-dialog.html',
                    controller: 'TechnicienDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                displayname: null,
                                firstName: null,
                                lastName: null,
                                email: null,
                                enabled: false,
                                aliases: [''],
                                cost: null,
                                astreinteCost: null,
                                costDetail: null,
                                id: null,
                                planningEquipe: true
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('technicien', null, { reload: 'technicien' });
                }, function() {
                    $state.go('technicien');
                });
            }]
        })
        .state('technicien.edit', {
            parent: 'technicien',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/technicien/technicien-dialog.html',
                    controller: 'TechnicienDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Technicien', function(Technicien) {
                            return Technicien.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('technicien', null, { reload: 'technicien' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('technicien.delete', {
            parent: 'technicien',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/technicien/technicien-delete-dialog.html',
                    controller: 'TechnicienDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Technicien', function(Technicien) {
                            return Technicien.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('technicien', null, { reload: 'technicien' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
